import './OneStopOverlay.css'
import { useLocation, useNavigate } from 'react-router-dom';

export const OnestopOverlay = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = location
    if(pathname.includes("onestop")) {
        return <></>
    }

    return (
        <div id="onestop-overlay" onClick={() => navigate('onestop')}>Return to OneStop.</div>
    );
};